import * as i0 from '@angular/core';
import { Input, ChangeDetectionStrategy, Component } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = a0 => ({
  fullscreen: a0
});
let EzSpinnerComponent = /*#__PURE__*/(() => {
  class EzSpinnerComponent {
    constructor() {
      this.fullscreen = false;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function EzSpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EzSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EzSpinnerComponent,
        selectors: [["ez-spinner"]],
        inputs: {
          fullscreen: "fullscreen"
        },
        decls: 2,
        vars: 3,
        consts: [[1, "spinner", 3, "ngClass"]],
        template: function EzSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵelement(1, "p-progressSpinner");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx.fullscreen));
          }
        },
        dependencies: [CommonModule, i1.NgClass, ProgressSpinner],
        styles: [".spinner[_ngcontent-%COMP%]{margin:0 calc(50% - 50px)}.spinner.fullscreen[_ngcontent-%COMP%]{position:absolute;margin-top:calc(20% - 50px)}"],
        changeDetection: 0
      });
    }
  }
  return EzSpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { EzSpinnerComponent };
